import DOMPurify from 'dompurify';

/** Detects markup for presentation only; this is not a security check. */
export const isHtml = (content: string) => /<\/?[a-z][^>]*>/i.test(content);

/** Allows rich text formatting while removing executable content and injected styling. */
export const sanitizeHtml = (content?: string | null): string =>
  DOMPurify.sanitize(content ?? '', {
    ALLOWED_TAGS: [
      'p',
      'br',
      'div',
      'span',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'strong',
      'b',
      'em',
      'i',
      'u',
      's',
      'ul',
      'ol',
      'li',
      'a',
      'blockquote',
      'pre',
      'code',
      'hr',
      'table',
      'thead',
      'tbody',
      'tfoot',
      'tr',
      'th',
      'td',
      'img',
      'sub',
      'sup'
    ],
    ALLOWED_ATTR: ['href', 'title', 'src', 'alt', 'colspan', 'rowspan', 'scope']
  });
